<template>
    <div class="shop-container" v-loading.fullscreen="loading">
        <div class="tab"><i>{{$t('Details')}}</i></div>
        <div class="det-con">
            <p v-html="pageData.content"></p>
        </div>
    </div>
</template>

<script>
import BaseSwiper from './s.vue'
export default {
    components:{
        BaseSwiper
    },
    data() {
        return {
            center: {
                lng: 0,
                lat: 0
            },
            zoom: 20,
            active: false,
            pageData: {},
            loading: false,
            longitude: "",
            latitude: ""
        }
    },
    created() {
        this.list()
    },
    mounted() {
        // this.init();
    },
    methods: {
        init(longitude, latitude) {

            return
            let address = "";
            let that = this;

            this.$nextTick(() =>{
                var center = new google.maps.LatLng(latitude, longitude);
                var map = new google.maps.Map(document.getElementById('map'), {
                    center: center,
                    zoom: 13,
                    disableDefaultUI: true
                });
                var marker = new google.maps.Marker({
                    position: center,
                    map: map
                });
                var infoWin = new google.maps.InfoWindow({
                    map: map
                });
                var geocoder = new google.maps.Geocoder({
                    complete: function(res) {
                    console.log(res);
                    address = res.detail.nearPois[0].name;
                    }
                });
            })
            
        },
        list() {
            this.loading = true
            let id = this.$route.query.id
            this.$api.picturedetail({
                id
            }).then(res =>{
                setTimeout(() => {
                    this.loading = false
                })
                if(res.status) {
                    this.pageData = res.data
                    this.init( this.pageData.longitude, this.pageData.latitude)
                } 
            })
        },
        handler() {
            this.center.lng = this.pageData.longitude
            this.center.lat = this.pageData.latitude
        },
        draw ({el, BMap, map}) {
            const pixel = map.pointToOverlayPixel(new BMap.Point(this.pageData.longitude, this.pageData.latitude))
            el.style.left = pixel.x - 50 + 'px'
            el.style.top = pixel.y - 50 + 'px'
        }
     }
}
</script>

<style lang="scss" scoped>

.sample {
  width: 90px;
  height: 18px;
  line-height: 8px;
  background: url('http://www.sanlida.cn/templates/pccommon/images/ico_mark_3.png') no-repeat;
  background-size:  100% 100%;
  overflow: hidden;
  color: #fff;
  text-align: center;
  padding: 10px;
  position: absolute;
  font-size: 12px;
}
.sample.active {
  color: #fff;
}


.shop-container {
    overflow: hidden;
}
.tab{
    width: 100%;
    float: left;
    margin-top: 20px;
    border-bottom: 2px solid #e7442f;
    i{
        color: #fff;
        font-size: 18px;
        padding:10px 20px;
        background: #e7442f;
        float: left;
    }
}
.det-item {
    width: 1226px;
    float: left;
    padding: 10px 20px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    &-left {
        width: 750px;
        float: left;
        font-size: 14px;
        p {
            color: #333;
            font-size: 18px;
            margin: 10px 0;
            font-weight: 600;
        }
        ul {
            li {
                width: 100%;
                float: left;
                margin-bottom: 8px;
                i{
                    min-width: 80px;
                    float: left;
                    color: #333;
                    font-weight: 600;
                    line-height: 22px;
                }
                span {
                    max-width: 600px;
                    float: left;
                    line-height: 22px;
                }
            }
        }
    }
    &-right {
        float: right;
        width: 200px;
        margin: 25px 20px 0 0;
        box-shadow: 0 0 15px rgba(0, 0, 0, .1);
        img {
            width: 200px;
            height: 200px;
        }
    }
}
.det-pic {
    width: 1226px;
    float: left;
    padding: 10px 20px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    .gallery-wrapper {
        height: 195px;
        width: 100%;
        overflow: hidden;
        position: relative;
        ul {
            height:195px;
            width:100000px;
            position:absolute;
            left:0;
            z-index: 100;
            li {
                display:block;
                float:left;
                margin:5px;
                height:185px;
                position:relative;
                img {
                    width: 260px;
                    height: 185px;
                }
            }
        }
    }
}

span{
    p {
        img{
            width: 100% !important;
        }
    }
    
}
.bm-view {
  width: 100%;
  height: 400px;
  float: left;
}

.det-con {
    width: 1226px;
    float: left;
    font-size: 14px;
    line-height: 24px;
    padding:10px 20px;
    border:1px solid #e5e5e5;
    box-sizing: border-box;
    
}
</style>

<style scoped>

.det-con p >>> img {
    width: 100%;
}
.html-content >>> img {
    width: 100%;
}
</style>